
// import apis from '@/apis';
// import { useNavigate, useLocation } from 'react-router-dom'
// import { useUserInfoStore } from '@/stores'
import { Navigate } from 'react-router-dom'
// import { useEffect, useState } from 'react'
import { useUserInfo } from '@/hooks/userContext'
import router from '@/router'
import type { Route } from '@/types/common'
import { storageUtil, routesMap, utils } from '@/utils'


const { getUrlParameters, objectToQueryString } = utils
// const { user: userApi } = apis
function RouterGuard({ children }: any) {
  // const userInfoStore = useUserInfoStore();
  const currentPath = window.location.pathname;
  const routerItem: Route = router.routes.find((item: any) => item.path === currentPath) as unknown as Route ?? { name: '', element: null, path: currentPath };
  const accessToken = storageUtil.getSessionStorage('accessToken')
  const uid = storageUtil.getSessionStorage('uid')
  const { userInfo, loading } = useUserInfo()
  const urlParame: any = getUrlParameters(location.search)

  if (['AgentCoin', 'AgentTransferRrecord'].includes(routerItem.name)) {
    if (!accessToken || !uid) {
      const search = objectToQueryString({
        ...urlParame,
      })
      return <Navigate to={ `${routesMap.Login}${search ? '?' + search : ''}` } replace />
    } else {
      return children
    }
  }

  // if (routerItem.name === 'AgentLogin') {
  //   // 已经登录 并且是 代理商直接跳转代理商页面
  //   if (userInfo && userInfo.agent === 1) {
  //     return <Navigate to={ `${routesMap.AgentCoin}${location.search}` } replace />
  //   } else {
  //     return children
  //   }
  // }

  // const userInfoStore = useUserInfoStore()
  // 获取当前用户信息
  // async function getMyAccountInfo () {
  //   const [err, res] = await to(
  //     userApi.getMyAccountInfo({}),
  //   )

  //   if (err) return

  //   setGuildId(res.res.guildId)
  //   userInfoStore.setUserInfo(res.res)
  // }

  // 使用 useEffect 在组件挂载时调用异步函数
  // useEffect(() => {
  //   console.log('RouterGuard')
  //   getMyAccountInfo()
  // })

  // 如果数据还在加载，显示 loading 页面
  if (loading) return '';

  if (userInfo.guildId > 0) {
    return children
  } else {
    let search = ''
    if (urlParame.source === '0') {
      search = objectToQueryString({
        ...urlParame,
        source: 0,
      })
    } else {
      search = objectToQueryString({
        ...urlParame,
        source: 0,
        isClose: 1,
      })
    }
    
    // 没有加入公会跳转到公会列表
    return <Navigate to={ `${routesMap.GuildList}?${search}` } replace />
  }
}

export default RouterGuard